"use client";

import { Toaster } from "sonner";

export interface JanewayToasterProps {
  /** Default: "bottom-right". */
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right" | "top-center" | "bottom-center";
}

/**
 * Der Toaster der Suite. `SplashWrapper` rendert ihn selbst; einzeln nur fuer
 * Apps ohne diese Huelle (janeway-admin).
 */
export function JanewayToaster({ position = "bottom-right" }: JanewayToasterProps) {
  return (
    /* M-092: `--jw-toast-unten` am Gebrauchsort lesen — eine App hebt die
       Toasts damit ueber eigene Bedienleisten (mail-client: Fuss des
       Verfassen-Fensters). Rueckfall = Sonners Vorgabe (24 px, Handy 16 px)
       plus die Streifen von Cookie-Hinweis und Installationsbanner, die beide
       ihre Hoehe melden — sonst lag ein Toast am Handy auf „So installierst du
       sie" (Audit 2026-10-06). Im RUECKFALL, damit eine App mit eigener
       Variable (mail-client) weiter gewinnt.
       M-109: Live-Region und Schliessknopf heissen vorgelesen deutsch. */
    /* Desktop: ganz unten rechts, LINKS neben dem Jane-Knopf (`--jw-jane-knopf-seite`, von
       `AppLayout` an <html> gesetzt, solange Jane steht). Die Keksleiste hebt hier nicht mehr an:
       ab `sm` ist sie eine Karte unten LINKS — mit ihrer Hoehe rutschte der Toast rechts genau auf
       den Jane-Knopf, der ebenfalls um sie angehoben ist (2026-10-21, Betreiber-Meldung).
       Am Handy deckt sie die ganze Breite, dort bleibt der Aufschlag. */
    <Toaster
      position={position}
      style={{ zIndex: 2147483000 }}
      offset={{
        bottom: "var(--jw-toast-unten, calc(24px + var(--jw-installleiste-h, 0px)))",
        right: "calc(24px + var(--jw-jane-knopf-seite, 0px))",
      }}
      // Am Handy ist der Toast so breit wie der Schirm — dort geht er UEBER den Jane-Knopf.
      mobileOffset={{ bottom: "var(--jw-toast-unten, calc(16px + var(--jw-jane-knopf-hoehe, 0px) + var(--jw-cookieleiste-h, 0px) + var(--jw-installleiste-h, 0px)))" }}
      containerAriaLabel="Benachrichtigungen"
      closeButton
      toastOptions={{
        closeButtonAriaLabel: "Hinweis schließen",
        className:
          "!bg-card !text-card-foreground !border-border !rounded-[var(--radius)] !shadow-lg",
        descriptionClassName: "!text-muted-foreground",
        actionButtonStyle: {
          backgroundColor: "var(--color-primary)",
          color: "var(--color-primary-foreground)",
          borderRadius: "var(--radius)",
        },
        cancelButtonStyle: {
          backgroundColor: "var(--color-muted)",
          color: "var(--color-muted-foreground)",
          borderRadius: "var(--radius)",
        },
      }}
    />
  );
}
